export default "__VITE_ASSET__CFwaBfCL__"